import * as Config from "@/config";
import { Faq } from "@/types/faq";
import { RefObject } from "react";

// TODO: 共通関数

export const controlNum = (data_id: number) => {
  return String(data_id).padStart(5, "0");
};

export const addDisplayNum = (faqs: any[]): any[] => {
  return faqs.map((faq, index) => {
    return { ...faq, display_num: index + 1 };
  });
};

export const filterFaqs = (
  faqs: Faq[],
  checkTypeIds: number[],
  checkKindIds: number[],
  searchText: string
) => {
  const texts = searchText.split(/[\s　]+/);
  if (checkTypeIds.length > 0) {
    faqs = faqs.filter((faq) =>
      faq.faq_type.some((type) => checkTypeIds.includes(type.id))
    );
  }
  if (checkKindIds.length > 0) {
    faqs = faqs.filter((faq) =>
      faq.faq_kind.some((kind) => checkKindIds.includes(kind.id))
    );
  }
  if (texts.length > 0 && searchText.trim() !== "") {
    faqs = faqs.filter((faq) =>
      texts.some((text) => {
        const lowerText = text.toLowerCase();
        return (
          faq.title.toLowerCase().includes(lowerText) ||
          faq.question.toLowerCase().includes(lowerText) ||
          faq.answer.toLowerCase().includes(lowerText)
        );
      })
    );
  }
  return faqs;
};

export const isWithinLast15Days = (date: string) => {
  const inputDate = new Date(date);
  const today = new Date();
  const diff = today.getTime() - inputDate.getTime();
  const diffDays = diff / (24 * 60 * 60 * 1000);
  return diffDays <= 15;
};

export const paginateCurrentValues = (
  currentPage: number,
  pageSize: string,
  faqList: Faq[]
) => {
  const indexOfLastItem = (currentPage + 1) * Number(pageSize);
  const firstItemNum = indexOfLastItem - Number(pageSize);
  const lastItemNum =
    faqList.length < indexOfLastItem ? faqList.length : indexOfLastItem;
  const currentItems = faqList.slice(firstItemNum, indexOfLastItem);

  return { firstItemNum, lastItemNum, currentItems };
};

export const inputAttributeOptionValue = (attributeOption: any) => {
  return createAttributeOptionValue(
    attributeOption.id,
    attributeOption.code,
    attributeOption.option
  );
};
// TODO: 値の持ち方検討→selectにはoption_idで持っておいてget/postの際にcode_valueで検索
export const createAttributeOptionValue = (
  attribute_option_id: any,
  attribute_code: any,
  attribute_value: any
) => {
  return (
    attribute_option_id +
    Config.SPLIT_CODE +
    attribute_code +
    Config.SPLIT_CODE +
    attribute_value
  );
};

export const inputAttributeToPostParam = (
  attributes: Array<any>,
  data: any,
  dataMap: Map<string, any> | undefined = undefined
): any => {
  const inputAttributes = {} as any;
  if (!data.attributes) return inputAttributes;
  for (const attribute of attributes) {
    const inputValue = data.attributes[attribute.id];
    if (!inputValue || inputValue.length === 0) continue;
    const dataAttributeValue = dataMap?.get(attribute.id) || undefined;
    if (Config.ATTRIBUTE_CODES.includes(attribute.attribute_kind_code)) {
      const values: any[] = [];
      if (Array.isArray(inputValue)) {
        for (const check of inputValue) {
          const [option_id, code, value] = check.split(Config.SPLIT_CODE);
          const setValue = {
            attribute_code: code,
            attribute_value: value,
          } as any;
          if (dataAttributeValue) {
            const existsData = existsDataAttributeValue(
              code,
              value,
              dataAttributeValue
            );
            if (existsData) setValue["id"] = existsData.id;
          }
          values.push(setValue);
        }
        inputAttributes[attribute.id] = values;
      }
      if (
        typeof inputValue === "string" &&
        inputValue.includes(Config.SPLIT_CODE)
      ) {
        console.log(inputValue);
        const [option_id, code, value] = inputValue.split(Config.SPLIT_CODE);
        const setValue = {
          attribute_code: code,
          attribute_value: value,
        } as any;
        if (dataAttributeValue) {
          const existsData = existsDataAttributeValue(
            code,
            value,
            dataAttributeValue
          );
          if (existsData) setValue["id"] = existsData.id;
        }
        inputAttributes[attribute.id] = setValue;
      } else {
        inputAttributes[attribute.id] = { attribute_value: inputValue };
        if (dataAttributeValue) {
          inputAttributes[attribute.id]["id"] = dataAttributeValue.id;
        }
      }
    } else {
      inputAttributes[attribute.id] = { attribute_value: inputValue };
      if (dataAttributeValue) {
        inputAttributes[attribute.id]["id"] = dataAttributeValue.id;
      }
    }
  }
  return inputAttributes;
};

export const existsDataAttributeValue = (
  attribute_code: string,
  attribute_value: string,
  dataAttributeValue: any
): any => {
  if (Array.isArray(dataAttributeValue)) {
    for (const check of dataAttributeValue) {
      if (
        attribute_code === check.attribute_code &&
        attribute_value === check.attribute_value
      )
        return check;
    }
  } else {
    if (
      attribute_code === dataAttributeValue.attribute_code &&
      attribute_value === dataAttributeValue.attribute_value
    )
      return dataAttributeValue;
  }
  return undefined;
};

export const convertToKeyMap = (
  datas: Array<any>,
  key: string
): Map<string, any> => {
  const map = new Map();
  for (const data of datas) {
    if (map.has(data[key])) {
      const value = map.get(data[key]);
      if (Array.isArray(value)) {
        value.push(data);
      } else {
        const array = [value, data];
        map.set(data[key], array);
      }
    } else {
      map.set(data[key], data);
    }
  }
  return map;
};

export const getNestedValue = (data: any): any => {
  if (typeof data === "object")
    return getNestedValue(data[Object.keys(data)[0]]);
  else return data;
};

/* DBから取得したエリア一覧（ツリー含む）からエリアを探す */
export const getArea = (areas: any[], id: number): any | null => {
  for (const area of areas) {
    const result = getAreaById(area, id);
    if (result) {
      return result;
    }
  }
  return null;
};

/* ツリーのエリアデータから子エリアを探す */
export const getAreaById = (area: any, id: number): any | null => {
  if (area.id == id) {
    return area;
  }
  if (area.children) {
    for (const child of area.children) {
      const result = getAreaById(child, id);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

/* 申込エリアの名リストを取得する */
export const getSelectedAreaList = (applyAreas: any[], areas: any[]) => {
  return applyAreas
    .map((item) => getArea(areas, item.sales_product_id))
    .filter((item) => item != null);
};

/* react-hook-formのフォーム値から実際のvalueを取得する */
export const extractValue = (composed: string) => {
  const values = composed.split(Config.SPLIT_CODE);
  if (values.length == 3) {
    return values[2];
  } else {
    return composed;
  }
};

export const filesToPostParam = (files: any[]): any => {
  const toBase64 = (file: File) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  return Promise.all(
    files.map(async (item) => {
      const base64 = await toBase64(item.file);
      return {
        file_name: item.file.name,
        file_content: base64,
        file_attribute_code: Config.FILE_ATTRIBUTE_CODE_ATTACHED_FILE,
      };
    })
  );
};

export const formatPrice = (number: number) => {
  const formatter = new Intl.NumberFormat("ja-JP");
  return formatter.format(number);
};

export const isInvalidEmail = (value: string) => {
  const regex =
    /^(?=.{1,254}$)(?=.{1,64}@)[0-9A-Za-z._%+-]+(\.[0-9A-Za-z]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
  if (!regex.test(value)) {
    return "メールアドレスが不正値です。";
  }
  return true;
};

export const maxSizeSum = (value: any) => {
  let totalSize = 0;
  for (let i = 0; i < value.length; i++) {
    totalSize += value[i]?.file?.size || 0;
  }
  return totalSize <= 1024 * 1024 * 10 || Config.MESSAGE_NO_E11;
};

export const smoothScroll = (
  scrollRef: RefObject<HTMLDivElement>,
  yOffset: number
) => {
  if (scrollRef.current) {
    // const yOffset = -70;
    const y = scrollRef.current.getBoundingClientRect().top + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export const addColorClass = (text: string, searchString: string) => {
  return text.toLowerCase().includes(searchString.toLowerCase())
    ? { color: "red" }
    : {};
};
